import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Box,
  Stack,
  IconButton,
  useMediaQuery,
  useTheme,
  Button,
} from '@mui/material';
import { useDialogs } from '@toolpad/core/useDialogs';
import { PinturaDefaultImageWriterResult } from '@pqina/pintura';

import { FlipIcon, RotateIcon, ResetIcon, DecorateIcon } from '@ui/icons';
import { useGetSpacing } from '@ui';
import { useEditorStore } from './EditorStore';
import { DecorationSelectionDialog } from './DecorationSelectionDialog';

export const EditorMenu: FC = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const dialogs = useDialogs();
  const { t } = useTranslation();

  const getSpacing = useGetSpacing();
  const {
    editor,
    // rotationInputEnabled,
    toggleImageFlipX,
    // enableZoomInput,
    // enableRotationInput,
    setTempImage,
  } = useEditorStore();

  // let state = 'enableZoomInput';
  // if (rotationInputEnabled) {
  //   state = 'enableRotationInput';
  // }

  // const handleChangeState = (
  //   _event: React.MouseEvent<HTMLElement>,
  //   newState: string | null
  // ) => {
  //   if (newState === null) return; // No change
  //   if (newState === 'enableZoomInput') {
  //     enableZoomInput();
  //   } else if (newState === 'enableRotationInput') {
  //     enableRotationInput();
  //   }
  // };

  const handleOpenDecorationSelectionDialog = () => {
    editor?.processImage().then((data: PinturaDefaultImageWriterResult) => {
      setTempImage(data.dest);
      dialogs.open(DecorationSelectionDialog);
    });
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <Box
        sx={{
          boxSizing: 'border-box',
          alignItems: 'center',
          display: 'inline-block',
          position: 'relative',
          width: '100%',
          zIndex: 5,
          height: {
            xs: 64,
            sm: 64,
            md: 72,
          },
          backgroundColor: '#FFFFFF',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            height: '100%',
            width: '100%',
            alignContent: 'stretch',
            justifyContent: 'center',
            alignSelf: 'auto',
            flexDirection: 'column',
            alignItems: 'center',
            flexShrink: 0,
            flexGrow: 0,
            position: 'absolute',
          }}
        >
          <Stack direction="row" spacing={getSpacing('m')}>
            {isSmallScreen ? (
              <>
                <IconButton
                  color="secondary"
                  onClick={() => {
                    if (editor && typeof editor.imageRotation === 'number') {
                      editor.imageRotation += Math.PI / -2;
                    }
                  }}
                >
                  <RotateIcon />
                </IconButton>
                <IconButton
                  color="secondary"
                  onClick={() => toggleImageFlipX()}
                >
                  <FlipIcon />
                </IconButton>
              </>
            ) : (
              <>
                <Button
                  onClick={() => {
                    if (editor && typeof editor.imageRotation === 'number') {
                      editor.imageRotation += Math.PI / -2;
                    }
                  }}
                  startIcon={<RotateIcon />}
                >
                  {t('rotateLeft')}
                </Button>
                <Button
                  onClick={() => toggleImageFlipX()}
                  startIcon={<FlipIcon />}
                >
                  {t('flipHorizontal')}
                </Button>
              </>
            )}
          </Stack>
          {/* <ToggleButtonGroup
            value={state}
            exclusive
            onChange={handleChangeState}
            aria-label="text alignment"
          >
            <ToggleButton value="enableZoomInput" aria-label="left aligned">
              {isSmallScreen ? <ScaleIcon /> : 'Skalieren'}
            </ToggleButton>
            <ToggleButton value="enableRotationInput" aria-label="centered">
              {isSmallScreen ? <RotateIcon /> : 'Drehen'}
            </ToggleButton>
          </ToggleButtonGroup> */}
        </Box>

        <Box
          sx={{
            float: 'left',
            alignItems: 'center',
            display: 'flex',
            flexBasis: 78,
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'center',
            position: 'relative',
            paddingLeft: getSpacing('xl'),
          }}
        >
          {editor && (
            <>
              {isSmallScreen ? (
                <IconButton
                  color="secondary"
                  aria-label="reset"
                  onClick={() => editor.history.revert()}
                >
                  <ResetIcon />
                </IconButton>
              ) : (
                <Button
                  aria-label="reset"
                  onClick={() => editor.history.revert()}
                  startIcon={<ResetIcon />}
                >
                  {t('reset')}
                </Button>
              )}
            </>
          )}
        </Box>
        <Box
          sx={{
            float: 'right',
            alignItems: 'center',
            display: 'flex',
            flexBasis: 78,
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'center',
            position: 'relative',
            paddingRight: getSpacing('xl'),
          }}
        >
          {isSmallScreen ? (
            <IconButton
              color="secondary"
              aria-label="close"
              onClick={handleOpenDecorationSelectionDialog}
            >
              <DecorateIcon sx={{ fontSize: 16 }} />
            </IconButton>
          ) : (
            <Button
              aria-label="close"
              onClick={handleOpenDecorationSelectionDialog}
              startIcon={<DecorateIcon />}
            >
              {t('addDecoration')}
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
};
